import React from "react";
import { Table, Skeleton } from "antd";
import Column from "antd/es/table/Column";
import NoDataIcon from "../../../assets/svg/no-data.svg";
import { useTranslation } from "react-i18next";

const VillageDataTable = ({
  isDataAvailable,
  data,
  villageFetchedData,
  selectedMarker,
  villageLoading
}) => {
  const { t } = useTranslation();
  const themes = localStorage.getItem("themes") 
  return (
    <div className='constituenct-data-table '>
      <h1>
        {selectedMarker?.title || t("Village")} {t("Form 20 Data")}
      </h1>

      {isDataAvailable ? (
        <Table style={{boxSizing: "border-box"}}
          scroll={{ x: "max-content" }}

          rowKey={(record) => record.type}
          dataSource={data}
          locale={{
            emptyText:
              villageLoading || !data ? (
                <div
                  style={{
                    marginLeft: "20px",
                    marginTop: "20px",
                    width: "95%",
                    boxSizing: "border-box"
                  }}
                >
                  {" "}
                  {/* Container with 90% width */}
                  <Skeleton
                    title={false}
                    active
                    paragraph={{
                      rows: 5,
                      width: ["100%", "100%", "100%", "100%", "100%"],
                      height: ["30px", "30px", "30px", "30px", "30px"]
                    }}
                  />
                </div>
              ) : (
                <div className='no-data-icon mt-20'>
                  <img src={NoDataIcon} alt='' />
                  <h1>{t("No Data Available")}</h1>
                </div>
              )
          }}
        >
          <Column
            title='Party'
            dataIndex='partyName'
             render={(text, record) => {
              let color = record.partyColorCode;

              if (text === "Total") {
                color = themes === 'darkMode' ? "#fff" : record.partyColorCode;
              } else if (text === "others") {
                color = themes === 'darkMode' ? "#D3D3D3" : record.partyColorCode;
              }

              return (
                <span
                  style={{
                    fontWeight: "bold",
                    color: color
                  }}
                >
                  {text}
                </span>
              );
            }}
          />
          <Column
            title='Vote Share'
            dataIndex='voteShare'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />

          <Column
            title='Vote Share%'
            dataIndex='voteSharePercentage'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined
                  ? `${parseFloat(text).toFixed(2)}%`
                  : "-"}
              </div>
            )}
          />

          <Column
            title='Polling Station'
            dataIndex='noOfPSWon'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />
        </Table>
      ) : (
        <div className='no-data-icon mt-20'>
          <img src={NoDataIcon} alt='' />
          <h1>{t("No Data Available")}</h1>
        </div>
      )}
    </div>
  );
};

export default VillageDataTable;
